module.exports = __webpack_public_path__ + "img/Incoming blue.93467865.png";